import { render } from "./LeaveDetail.vue?vue&type=template&id=899d64c2"
import script from "./LeaveDetail.vue?vue&type=script&lang=js"
export * from "./LeaveDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__